import React from 'react';
import { getPageClassName, getPageBodyClassName } from './utils.js';
import { AlertMessage } from '../AlertMessage/component.js';
import { AlertMessageTypes } from '../../constants/index.js';
import { PageFooter } from '../PageFooter.js';
import { PageHeader } from '../PageHeader.js';
import { PageWrapper } from '../Layout/PageWrapper.js';
import { Header } from '../Layout/Header.js';
import { Section } from '../Layout/Section.js';
import { Wrapper } from '../Layout/Wrapper.js';
import { Footer } from '../Layout/Footer.js';
import { ExplainerText } from '../ExplainerText/component.js';
/** renders the standard page layout that is used in Foundry */

var Page = function Page(_ref) {
  var actionButton = _ref.actionButton,
      backButton = _ref.backButton,
      banner = _ref.banner,
      children = _ref.children,
      className = _ref.className,
      clearMessages = _ref.clearMessages,
      _ref$contentType = _ref.contentType,
      contentType = _ref$contentType === void 0 ? 'fullwidth' : _ref$contentType,
      errorMessage = _ref.errorMessage,
      footerButtonBarClass = _ref.footerButtonBarClass,
      footerButtons = _ref.footerButtons,
      footerClass = _ref.footerClass,
      headingClass = _ref.headingClass,
      headerTabs = _ref.headerTabs,
      icon = _ref.icon,
      instructionalText = _ref.instructionalText,
      nestedPage = _ref.nestedPage,
      overrideTitle = _ref.overrideTitle,
      _ref$pageType = _ref.pageType,
      pageType = _ref$pageType === void 0 ? 'parent' : _ref$pageType,
      pageBodyClassName = _ref.pageBodyClassName,
      _ref$showAlertMessage = _ref.showAlertMessages,
      showAlertMessages = _ref$showAlertMessage === void 0 ? true : _ref$showAlertMessage,
      _ref$showHeader = _ref.showHeader,
      showHeader = _ref$showHeader === void 0 ? true : _ref$showHeader,
      successMessage = _ref.successMessage,
      title = _ref.title,
      toolbar = _ref.toolbar,
      usePageWrapper = _ref.usePageWrapper;

  var renderAlertMessage = function renderAlertMessage(messageType, message) {
    if (!message || !showAlertMessages) {
      return null;
    } else {
      return /*#__PURE__*/React.createElement(AlertMessage, {
        message: message,
        messageType: messageType,
        visible: !!message,
        clearMessages: clearMessages
      });
    }
  };

  var renderPageHeader = function renderPageHeader() {
    if (!showHeader) {
      return null;
    } else if (usePageWrapper) {
      return /*#__PURE__*/React.createElement(Header, {
        back: backButton,
        button: actionButton,
        title: title,
        icon: icon
      }, headerTabs, toolbar, banner);
    } else {
      return /*#__PURE__*/React.createElement(PageHeader, {
        actionButton: actionButton,
        backButton: backButton,
        title: title,
        icon: icon,
        banner: banner,
        headerTabs: headerTabs,
        headingClass: headingClass,
        overrideTitle: overrideTitle,
        toolbar: toolbar
      });
    }
  };

  var renderPageFooter = function renderPageFooter() {
    if (!footerButtons) {
      return null;
    } else if (usePageWrapper) {
      return /*#__PURE__*/React.createElement(Footer, {
        button: footerButtons,
        buttonClass: footerClass
      });
    } else {
      return /*#__PURE__*/React.createElement(PageFooter, {
        footerButtonBarClass: footerButtonBarClass,
        footerButtons: footerButtons,
        footerClass: footerClass
      });
    }
  };

  var renderPageBody = function renderPageBody() {
    if (usePageWrapper) {
      return /*#__PURE__*/React.createElement(Section, {
        className: getPageBodyClassName({
          usePageWrapper: usePageWrapper,
          pageBodyClassName: pageBodyClassName,
          banner: banner,
          toolbar: toolbar,
          footerButtons: footerButtons,
          headerTabs: headerTabs,
          showHeader: showHeader
        }),
        type: contentType
      }, instructionalText && /*#__PURE__*/React.createElement(ExplainerText, null, instructionalText), children);
    } else {
      return /*#__PURE__*/React.createElement("div", {
        className: getPageBodyClassName({
          usePageWrapper: usePageWrapper,
          pageBodyClassName: pageBodyClassName,
          banner: banner,
          toolbar: toolbar,
          footerButtons: footerButtons,
          headerTabs: headerTabs,
          showHeader: showHeader
        })
      }, instructionalText && /*#__PURE__*/React.createElement("div", {
        className: "instructional-text"
      }, instructionalText), children);
    }
  };

  var renderPageContent = function renderPageContent() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, renderAlertMessage(AlertMessageTypes.danger, errorMessage), renderAlertMessage(AlertMessageTypes.success, successMessage), renderPageHeader(), renderPageBody(), renderPageFooter());
  };

  if (usePageWrapper && nestedPage) {
    return /*#__PURE__*/React.createElement(Wrapper, null, renderPageContent());
  } else if (usePageWrapper) {
    return /*#__PURE__*/React.createElement(PageWrapper, null, renderPageContent());
  } else {
    return /*#__PURE__*/React.createElement("div", {
      className: getPageClassName(pageType, contentType, className)
    }, renderPageContent());
  }
};

export { Page };